<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'users',
                label: 'Users',
                sortable: false,
                searchable: true,
                display: 'name',
                displayAlt: 'email',
            },
            {
                value: 'frequency_sets',
                label: 'Frequency Sets',
                sortable: false,
                searchable: true,
                display: 'name',
                customCell: 'FrequencySetListCell',
            },
            {
                value: 'mobile_features',
                label: 'Features',
                sortable: false,
                searchable: true,
                display: 'name',
            },
        ]"
        :title="'User Groups'"
        :model="'user-groups'"
        :createText="'Create Group'"
        :options="['editable', 'deletable']"
        :deleteHandler="deleteHandler"
        data-test-id="user-groups-table"
    />
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },

    mixins: [canConfirm],

    methods: {
        async deleteHandler(groups, showDefaultConfirmation, performDelete) {
            const many = groups.length > 1
            const anyGroupIsDistributed = groups.some((group) => group.is_distributed)

            const confirmed = await this.confirm({
                message: many
                    ? 'Are you sure you want to delete the selected groups? This action cannot be undone.'
                    : 'Are you sure you want to delete this group? This action cannot be undone.',
                hint: anyGroupIsDistributed
                    ? `Note: Deleting ${many ? 'these groups' : 'this group'} will not affect any Distributions ` +
                      `${many ? 'they are' : 'it is'} associated with. To edit Distributions tied to ` +
                      `${many ? 'these groups' : 'this group'}, you must do so from the Distributions page.`
                    : null,
                acceptLabel: 'Delete',
                danger: true,
            })

            if (confirmed) {
                performDelete(groups.map((g) => g.id))
            }
        },
    },
}
</script>
